import { Fragment } from 'react'
import styles from '../UserChatBubble/index.module.scss'
import { MentionInMessage } from './MentionInMessage.jsx'
import { renderTextChunk } from './renderTextChunk.jsx'

export function UserMessageTextMention({
  mentionSegments,
  mentionLookup,
  hasMentionRoster,
  textClassName,
}) {
  return (
    <p className={textClassName}>
      {mentionSegments.map((segment, index) =>
        segment.type === 'mention' ? (
          hasMentionRoster ? (
            <MentionInMessage key={`mention-${index}`} mentionToken={segment.value} lookup={mentionLookup} />
          ) : (
            <span key={`mention-${index}`} className={styles.mentionInMessage}>
              {segment.value.startsWith('@') ? segment.value.slice(1) : segment.value}
            </span>
          )
        ) : (
          <Fragment key={`chunk-${index}`}>{renderTextChunk(segment.value, `chunk-${index}`)}</Fragment>
        ),
      )}
    </p>
  )
}
